<div>
    <label class="heading">Final Package (TLMS)</label>

    <div class="col-8" style="padding-left:15px">
        <div>
            <mat-form-field appearance="fill" class="col-4">
                <mat-label class="asterisk_input">Periods </mat-label>
                <mat-select #singleSelect (blur)='validateInput()' [(ngModel)]="periodChoosen">
                    <mat-option *ngIf="periodLst && periodLst.length>0">
                        <ngx-mat-select-search placeholderLabel="Search"
                            noEntriesFoundLabel="'No Matching Period Found'"
                            [formControl]="periodSearch"></ngx-mat-select-search>
                    </mat-option>
                    <ng-container *ngIf="periodLst && periodLst.length>0">
                        <mat-option *ngFor="let period of filteredPeriods | async" [value]="period">
                            {{period}}
                        </mat-option>
                    </ng-container>
                </mat-select>
                <mat-hint class="mat-error" *ngIf="enableError">{{periodErrorMsg}}</mat-hint>
            </mat-form-field>

        </div>

        <div>
            <mat-form-field appearance="fill" class="col-4">
                <mat-label class="asterisk_input">Domiciles </mat-label>
                <mat-select #domicileSelect (blur)='validateInput()' [(ngModel)]="domicileChoosen">

                    <mat-option *ngIf="domicilesLst && domicilesLst.length>0">
                        <ngx-mat-select-search placeholderLabel="Search"
                            noEntriesFoundLabel="'No Matching Domiciles Found'"
                            [formControl]="domicileSearch"></ngx-mat-select-search>
                    </mat-option>
                    <ng-container *ngIf="domicilesLst && domicilesLst.length>0">
                        <mat-option *ngFor="let domicile of filteredDomiciles | async" [value]="domicile">
                            {{domicile}}
                        </mat-option>
                    </ng-container>
                </mat-select>
                <mat-hint class="mat-error" *ngIf="enableError">{{domicileErrorMsg}}</mat-hint>
            </mat-form-field>
        </div>



        <div class="col-4 text-right mb-2">
            <button class="submit-btn" [disabled]="!enableSubmit" mat-raised-button (click)="view()">
                View
            </button>
        </div>
    </div>


</div>